import { render, staticRenderFns } from "./ViewedCard.vue?vue&type=template&id=558df90a&lang=pug&"
import script from "./ViewedCard.vue?vue&type=script&lang=js&"
export * from "./ViewedCard.vue?vue&type=script&lang=js&"
import style0 from "./ViewedCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports